import React from 'react';

import { prop, defaultTo } from 'ramda';

import clear from '../../../images/indeed_logo.svg';

import { FOHImage } from '../../ingredients';

export const FOHIndeedIcon = (props: any) => (
  <FOHImage
    source={{ uri: clear }}
    style={{ width: 80, height: 20, ...defaultTo({}, prop('style', props)) }}
  />
);
